import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';

export const fontFamily = getFontFamily();
